//
// Scroll to target
// --------------------------------------------------
// Used to smooth scroll to target, able to set offset if required (e.g. navigation is fixed)
// Prevents hashes being added to url for same page scroll to

import { PageUtils } from "./helpers/page-utils";
window.addEventListener('load', () => {
    document.querySelectorAll('button[data-destination]').forEach((scrollButton) => {
        const destination = scrollButton.dataset.destination;
        const targetElement = document.querySelector(destination);

        if (targetElement) {
            scrollButton.addEventListener('click', () => {
                PageUtils.scrollToTarget(targetElement);
            });
        }
    });
});